const INITIAL_STATE = {
    data: null
}

const DadosEmpresaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'dadosEmpresa': {

            return {
                ...state,
                data: action.payload.dadosEmpresa
            }
        }
        default: {
            return state
        }
    }
}

export default DadosEmpresaReducer